import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import React, { useState } from 'react';
import classnames from 'classnames';
import { Flex } from '@cognite/cogs-core';
import { useSlots, getThemeClassNames } from '@cognite/cogs-utils';
import { Dropdown } from '../dropdown/dropdown.js';
import { Trigger, Header, Footer, FooterButton, Body, BackButton, CloseButton, SearchBar, SelectPanelSegmentedControl, SelectAll, Item, Section } from './elements.js';
import { SelectPanelContext } from './select-panel-context.js';

/**
 * SelectPanel is a component that is used to display configuration options in a
 * dropdown.
 */
var SelectPanelInner = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var className = _a.className,
    themeProps = _a.themeProps,
    children = _a.children,
    otherProps = __rest(_a, ["className", "themeProps", "children"]);
  var _useSlots = useSlots(children, {
      trigger: Trigger,
      header: Header,
      footer: Footer,
      body: Body
    }),
    _useSlots2 = _slicedToArray(_useSlots, 1),
    slots = _useSlots2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  return jsx(SelectPanelContext.Provider, {
    value: {
      isVisible: isVisible,
      setIsVisible: setIsVisible
    },
    children: jsx(Dropdown, Object.assign({
      className: classnames.apply(undefined, ['cogs-lab', 'cogs-lab-select-panel'].concat(_toConsumableArray(getThemeClassNames(undefined, themeProps)), [className])),
      placement: "bottom-start",
      offset: {
        mainAxis: 4,
        crossAxis: 0
      },
      onShow: function onShow(open) {
        return setIsVisible(open);
      },
      onHide: function onHide(open) {
        return setIsVisible(open);
      },
      visible: isVisible,
      hideOnOutsideClick: false
    }, otherProps, {
      ref: ref,
      content: jsxs(Flex, {
        className: classnames('cogs-lab', 'cogs-lab-select-panel__dropdown-wrapper'),
        direction: "column",
        children: [slots.header, slots.body, slots.footer]
      }),
      children: slots.trigger
    }))
  });
});
var SelectPanel = Object.assign(SelectPanelInner, {
  Trigger: Trigger,
  Header: Header,
  Footer: Footer,
  FooterButton: FooterButton,
  Body: Body,
  BackButton: BackButton,
  CloseButton: CloseButton,
  SearchBar: SearchBar,
  SegmentedControl: SelectPanelSegmentedControl,
  SelectAll: SelectAll,
  Item: Item,
  Section: Section
});

export { SelectPanel };
